import React from "react";

const Color = ({ color }) => {
    return (
        <div style={{ display: "flex", gap: "10px" }}>
            <span style={{ backgroundColor: color || "transparent", padding: "2px 10px", borderRadius: "20%" }}></span>
            <span>{color}</span>
        </div>
    );
};

export default Color;
